var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.67,
    height: 21.774,
    viewBox: "0 0 21.67 21.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    d: "M15.886,13.048c-.27-.135-1.595-.786-1.842-.877s-.427-.134-.608.136-.7.876-.853,1.056-.315.2-.584.068a7.406,7.406,0,0,1-2.168-1.339,8.081,8.081,0,0,1-1.5-1.868c-.157-.27-.016-.416.118-.55s.27-.315.4-.472a1.865,1.865,0,0,0,.27-.451A.492.492,0,0,0,9.1,8.28c-.068-.135-.607-1.463-.831-2s-.442-.454-.607-.463-.345-.01-.517-.009a.988.988,0,0,0-.719.338,3.024,3.024,0,0,0-.944,2.249,5.247,5.247,0,0,0,1.1,2.789,12.026,12.026,0,0,0,4.606,4.071,15.228,15.228,0,0,0,1.537.567,3.677,3.677,0,0,0,1.7.107,2.78,2.78,0,0,0,1.82-1.282,2.238,2.238,0,0,0,.157-1.282c-.067-.113-.247-.18-.517-.315m-4.919,6.716h0A8.955,8.955,0,0,1,6.4,18.515l-.327-.194-3.394.891.905-3.31-.213-.339a8.968,8.968,0,1,1,7.6,4.2M18.6,3.165A10.792,10.792,0,0,0,1.617,16.183L.086,21.774l5.72-1.5a10.78,10.78,0,0,0,5.156,1.314h0A10.795,10.795,0,0,0,18.6,3.164Z",
    transform: "translate(-0.086)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c2305d3a42d1d6b1b7b22bc58454ef5e.svg";
export { ForwardRef as ReactComponent };